export const formatCurrency = (amount?: number) =>
  (amount ?? 0).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
